/**
 * Maintenance Module — API service (W2 Priority 4).
 *
 * Wraps the backend maintenance invoice endpoints (queue + allocated log).
 */
import axios from 'axios'
import { SETTINGS } from '@/config/settings'

const base = `${SETTINGS.API.baseUrl}/api/pms/maintenance/invoices`

function authHeaders() {
  const token = localStorage.getItem('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const client = axios.create({
  timeout: SETTINGS.API.timeout || 30000,
})

client.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() }
  return config
})

export default {
  list(params = {}) {
    return client.get(`${base}/`, { params }).then((r) => r.data)
  },
  /**
   * Manual creation. Accepts an object or FormData (when an attachment is
   * included).
   */
  create(payload) {
    const isFormData = payload instanceof FormData
    return client
      .post(`${base}/`, payload, {
        headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
      })
      .then((r) => r.data)
  },
  update(invoiceId, payload) {
    const isFormData = payload instanceof FormData
    return client
      .patch(`${base}/${invoiceId}/`, payload, {
        headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
      })
      .then((r) => r.data)
  },
  remove(invoiceId) {
    return client.delete(`${base}/${invoiceId}/`)
  },
  /**
   * Allocate an invoice. `target` accepts either:
   *   - a string (legacy): property id
   *   - an object: { property_id } or { property_group_id }
   */
  allocate(invoiceId, target) {
    const payload = typeof target === 'string'
      ? { property_id: target }
      : (target || {})
    return client
      .post(`${base}/${invoiceId}/allocate/`, payload)
      .then((r) => r.data)
  },
  dismiss(invoiceId) {
    return client.post(`${base}/${invoiceId}/dismiss/`).then((r) => r.data)
  },
  groups() {
    return client
      .get(`${SETTINGS.API.baseUrl}/api/pms/maintenance/groups/`)
      .then((r) => r.data)
  },
  inboundAddress() {
    return client
      .get(`${SETTINGS.API.baseUrl}/api/pms/maintenance/inbound-address/`)
      .then((r) => r.data)
  },
}
